import classNames from 'classnames';
import { Toman } from '@/components/svg-symbols/icons';
import { toNumberCommas } from '@/utils/string-helpers';
import { PricingType } from './types';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
interface Props extends PricingType {
  className?: string;
  isLanding?: boolean;
  isGoodbyeSummerLanding?: boolean;
}
export const Pricing = ({
  isLanding,
  isGoodbyeSummerLanding,
  basePrice = 0,
  discountPercent = 0,
  effectivePrice = 0,
  className = ''
}: Props) => {
  const hasDiscount = !!discountPercent;
  const {
    isMobile
  } = useMobileDetect();
  if (isGoodbyeSummerLanding) {
    return <div className={classNames('flex w-full items-center gap-1', className, {
      'justify-center': hasDiscount,
      'justify-start': !hasDiscount
    })}>
                {hasDiscount && <span className='text-caption-10 text-text-darkGray line-through lg:text-base'>
                        {toNumberCommas(basePrice)}
                    </span>}
                <div className='flex items-center gap-0.5 text-red-600'>
                    <span className='text-caption-12 font-medium lg:text-base lg:font-bold'>
                        {toNumberCommas(effectivePrice || basePrice)}
                    </span>
                    <Toman className='mb-1 h-3.5 w-3.5 text-red-600 lg:h-6 lg:w-6' />
                </div>
            </div>;
  }
  return <div className={classNames('flex items-center gap-1', className, {
    'w-full justify-end': isLanding && isMobile && hasDiscount
  })} data-sentry-component="Pricing" data-sentry-source-file="pricing.tsx">
            <div className='flex items-end gap-1'>
                <div className={classNames('flex flex-col items-center text-caption-10 lg:text-body-14')}>
                    {hasDiscount && <span className='text-text-darkGray line-through'>{toNumberCommas(basePrice)}</span>}

                    <div className={classNames('flex items-center', !hasDiscount && (isLanding ? 'justify-end pt-5 lg:pt-6' : 'justify-center pt-5 lg:pt-6'))}>
                        <span className='text-caption-12 font-medium text-text-black lg:text-body-14'>
                            {toNumberCommas(effectivePrice || basePrice)}
                        </span>
                    </div>
                </div>
                <Toman className='mb-1 h-4 w-4 text-text-black lg:h-5 lg:w-5' data-sentry-element="Toman" data-sentry-source-file="pricing.tsx" />
            </div>

            {hasDiscount && <p className='h-[16px] w-[26px] rounded-md bg-alert-error-dark text-center text-caption-10 font-medium text-text-white lg:mr-1 lg:h-[24px] lg:w-[40px] lg:rounded-lg lg:text-body-14'>
                    {discountPercent}٪
                </p>}
        </div>;
};